import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import AccountMenu from './AccountMenu';
import {Button, Dropdown, Layout, Modal, Typography} from 'antd';
import ChangePasswordForm from "./ChangePasswordForm";
import looseLeafStore from '../stores/LooseLeafStore';
import DashboardStore from '../stores/DashboardStore';
import newgenlogo from "../../src/images/newgenlogo.png";

const {Header} = Layout;
const {Title} = Typography;

@inject("appStore")
@observer
class TitleBar extends Component {
    state = {
        passwordModalVisible: false,
    };
    render() {
        const appStore = this.props.appStore;
        const large = newgenlogo;

        return (
            <div
                style={{
                    display: 'flex',
                    padding: 10,
                    justifyContent: 'center',
                    background:'#0081c8'    
                }}>
                <Title style={{padding: '0px 10px', margin: 0, fontSize:'18px', }} level={3}>
                    {/* {appStore.currentComponent.label} */}
                    <img src={large} style={{"width":"70px"}} />
                    <div style={{color:'#fff'}}>Loose Leaf</div>
                </Title>
               
                <div style={{display: 'flex', flex: 1}}>{this.props.children}</div>
                {this.renderMenu()}
            </div>
        );
    }

    showModal = () => this.setState({passwordModalVisible: true});

    hideModal = () => this.setState({passwordModalVisible: false});

    renderMenu() {
        const appStore = this.props.appStore;
        if (!appStore.isLoggedIn()) return null;

        return (
            <div style={{"marginTop":"5px"}}>
                {this.renderAddLooseLeafButton()}
                <Dropdown
                    overlay={<AccountMenu onClickChangePassword={this.showModal}/>}
                    trigger={['click']}
                    style={{marginRight: '-2%'}}>
                    <Button icon={'user'}/>
                </Dropdown>
                <Modal
                    visible={this.state.passwordModalVisible}
                    onCancel={this.hideModal}
                    footer={null}>
                    <ChangePasswordForm
                        onRequestClose={this.hideModal}
                        appStore={this.props.appStore}
                    />
                </Modal>
            </div>
        )
    }

    renderAddLooseLeafButton() {
        //|| this.props.appStore.currentComponent.key==='dashboard'
        if (this.props.appStore.currentComponent.key === 'awaitingSeeds') {
            return (
                <Button
                    key="add"
                    onClick={() => this.CreateNew()}
                    icon="plus"
                    style={{marginRight: 10}}
                />
            );
        }
        return null;
    }
    CreateNew=()=>{
        looseLeafStore.setDrawerVisible(true);
        looseLeafStore.rowclick = true;
        DashboardStore.setCreateData(true)
    }
}

export default TitleBar;
